// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"styles/variables.css\"","mobile-threshold-width":"760px","chip":"Chip_chip__Eb5q1","time":"Chip_time__1_MBS"};